(function () {
    angular
        .module('advancedapp')
        .component('articleResults', {
            restrict: 'E',
            bindings: {
                results: '<',
                showmore: '@',
                sitename: '@',
                url: '@',
                rootpageid: '@',
                limit: '<'
            },
            template: require('./article-results.html'),
            controller: controller,
            controllerAs: 'vm'
        });

    controller.$inject = ['$log', '$window', '$timeout', 'search_service'];

    function controller($log, $window, $timeout, search_service) {

        var vm = this;
        var limit = 40;

        vm.articleModel = {
            categories: [],
            sortBy: 0,
            rootPageId: vm.rootpageid,
            filterByNewsType: "",
            filterByAuthor: ""
        };

        vm.$onChanges = function (changesObj) {

            if (changesObj.results && changesObj.results.currentValue) {
                vm.results = changesObj.results.currentValue;
            }
            if (changesObj.filterByNewsType && changesObj.filterByNewsType.currentValue) {

                vm.articleModel.filterByNewsType = changesObj.filterByNewsType.currentValue;
                vm.results = changesObj.results.currentValue;
            }
            if (changesObj.filterByAuthor && changesObj.filterByAuthor.currentValue) {
                vm.articleModel.filterByAuthor = changesObj.filterByAuthor.currentValue;
                vm.results = changesObj.results.currentValue;
            }
        };

        vm.filterByNewsType = function (newsType) {
            //console.log(newsType);
            vm.articleModel = {
                categories: [],
                sortBy: 0,
                rootPageId: vm.rootpageid,
                filterByNewsType: newsType,
                filterByAuthor: "",
                searchTerm: ""
            };
            searchWithCats(vm.articleModel);
        };

        vm.filterByAuthorName = function (authorName) {
            //console.log(authorName);
            vm.articleModel = {
                categories: [],
                sortBy: 0,
                rootPageId: vm.rootpageid,
                filterByNewsType: "",
                filterByAuthor: authorName,
                searchTerm: ""
            };
            searchWithCats(vm.articleModel);
        };

        function searchWithCats(model) {
            /* as we are now forcing all urls to end with /, the search url no longer
                needs the leading / in the string concat below */
            var searchUrl = vm.url + 'search/';

            return search_service.search(searchUrl, model)
                .then(function (result) {
                    vm.results = result;
                    return result;
                });
        }

        vm.showmoreResult = function () {
            vm.limit = vm.limit + 20;
            $timeout(function () {
                Foundation.reInit($('[data-equalizer]'));
            }, 100);
        };
    }
})();